import React, { useState, useEffect, useMemo, useCallback } from "react";
import { ToastContainer } from "react-toastify";
import swal from "sweetalert";
import { Button, Modal } from "react-bootstrap";
// import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import PageTitle from "../../../layouts/PageTitle";
import Table from "../../../components/table/ReactTable/Table";
import { ColumnFilter } from "../../../components/table/ReactTable/ColumnFilter";
import { Badge } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { courierActions } from "../../../../_store";
import { Link } from "react-router-dom";
import Toastr from "../../../components/common/Toastr";
import generatePDF from "../../../components/export/generatePDF";
import generateXlsx from "../../../components/export/generateXlsx";
import useFullPageLoader from "../../../../hooks/useFullPageLoader";
import CommonService from "../../../../services/Common/CommonService";

const CourierType = () => {
  const COLUMNS = [
    {
      Header: "Courier Name",
      Footer: "Courier Name",
      accessor: "CourierTypeName",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Description",
      Footer: "Description",
      accessor: "Description",
      justify: "left",
      Cell: ({ value }) => {
        return (
          <>
            <div style={{ maxWidth: 236 }}> {value}</div>
          </>
        );
      },
      Filter: ColumnFilter,
    },
    {
      Header: "Created By",
      Footer: "Created By",
      accessor: "CreatedByName",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "Created Date",
      Footer: "Created Date",
      accessor: "CreatedDateString",
      fieldType: "Date",
      justify: "left",
      //Cell: ({ value }) => { return format(new Date(value), 'MM/dd/yyyy') },
      Filter: ColumnFilter,
    },
    {
      Header: "Status",
      Footer: "Status",
      accessor: "StatusName",
      justify: "center",
      Cell: ({ value }) => {
        return (
          <>
            <Badge variant="primary light badge-lg"> {value}</Badge>
          </>
        );
      },
      Filter: ColumnFilter,
    },
    {
      Header: "",
      Footer: "",
      accessor: "CourierTypeID",
      disableFilters: true,
      Cell: ({ value }) => {
        return (
          <>
            <div className="d-flex">
              <Link
                onClick={() => handleEditClick(value)}
                className="btn btn-primary shadow btn-xs sharp me-1"
                title="Edit"
              >
                <i className="fas fa-pen"></i>
              </Link>
              <Link
                onClick={() => handleDeleteClick(value)}
                className="btn btn-danger shadow btn-xs sharp"
                title="Delete"
              >
                <i className="fa fa-trash"></i>
              </Link>
            </div>
          </>
        );
      },
    },
  ];

  const columns = useMemo(() => COLUMNS, []);

  const generateColumns = [
    {
      header: "Courier Name",
      dataKey: "CourierTypeName",
    },
    {
      header: "Description",
      dataKey: "Description",
    },
    {
      header: "Created By",
      dataKey: "CreatedByName",
    },
    {
      header: "Created Date",
      dataKey: "CreatedDateString",
    },
    {
      header: "Status",
      dataKey: "StatusName",
    },
  ];

  const dispatch = useDispatch();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const currentUser = useSelector((x) => x.auth.user);
  const courierType = useSelector((x) => x.courier.courierType);
  const courierTypeList = useSelector((x) => x.courier.courierTypeList);
  const courierResponse = useSelector((x) => x.courier.courierResponse);

  const deleteCourierResponse = useSelector(
    (x) => x.courier.deleteCourierResponse
  );

  const [isOpenModal, setOpenModal] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const isLoading = useSelector((x) => x.courier.isLoading);
  const [stateList, setStateList] = useState([]);
  const [finalTableData, setFinalTableData] = useState([]);

  const handleTableDataUpdate = useCallback((data) => {
    setFinalTableData(data);
  }, []);

  useEffect(() => {
    showLoader();

    dispatch(courierActions.getCourierTypeAll());
  }, [dispatch]);

  useEffect(() => {
    if (isLoading) {
      hideLoader();
    }
  }, [isLoading]);
  //Add State
  const [addFormData, setAddFormData] = useState({
    CourierTypeID: 0,
    CourierTypeName: "",
    Description: "",
    Status: 1,
    CreatedBy: currentUser.Id,
  });
  const newFormData = { ...addFormData };

  let styles = {
    control: (styles) => ({ ...styles, border: "1px solid red" }),
  };

  // handle Change function
  const handleChange = (event) => {
    event.preventDefault();
    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;
    if (fieldValue && fieldValue.trim()) {
      newFormData[fieldName] = fieldValue;
    } else {
      newFormData[fieldName] = fieldValue.trim();
    }
    setAddFormData(newFormData);
  };

  // Submit data function
  const handleSubmit = (event) => {
    event.preventDefault();
    var error = false;
    if (!addFormData.CourierTypeName) {
      error = true;
    }

    if (!error) {
      dispatch(courierActions.saveCourier(newFormData));
    } else {
      setSubmitted(true);
      // alertMsg="Missing";
      Toastr("Please fill in the required missing fields", "warning");
    }
  };
  // handle Check Box Click function
  const handleCkBoxChange = (event, title) => {
    let hasChecked = event.target.checked === true ? 1 : 2;
    if (
      !event.target.checked &&
      newFormData.CourierTypeID &&
      newFormData.CourierTypeID > 0
    ) {
      showLoader();

      let Param = { DeleteID: newFormData.CourierTypeID, DeleteType: 9 };
      CommonService.CheckMappedItem(Param).then((res) => {
        if (res.data === 1) {
          newFormData[title] = hasChecked;
          setAddFormData(newFormData);
          hideLoader();
        } else {
          Toastr("This Courier Type is already mapped", "warning");
          hideLoader();
        }
      });
    } else {
      newFormData[title] = hasChecked;
      setAddFormData(newFormData);
    }
  };

  const handlePoupClick = () => {
    newFormData.CourierTypeID = 0;
    newFormData.CourierTypeName = "";
    newFormData.Description = "";

    newFormData.Status = 1;

    setAddFormData(newFormData);
    setOpenModal(true);
    setSubmitted(false);
    setStateList([]);
  };
  const handleEditClick = (Id) => {
    showLoader();
    dispatch(courierActions.getCourierById({ CourierTypeID: Id }))
      .then((response) => {
        if (response.type === "courier/getCourierById/fulfilled") {
          if (response.payload) {
            let courierType = response.payload ? response.payload[0] : null;

            if (courierType && courierType.CourierTypeID > 0) {
              newFormData.CourierTypeID = courierType.CourierTypeID;
              newFormData.CourierTypeName = courierType.CourierTypeName;
              newFormData.Description = courierType.Description;
              newFormData.Status = courierType.Status;
              setAddFormData(newFormData);

              setOpenModal(true);
              setSubmitted(false);
            }
          } else {
            Toastr("Error", "warning");
          }
        } else {
          Toastr("Failed ", "warning");
        }
      })
      .catch((error) => {
        console.error("API call failed:", error);
        Toastr("Network error or server issue.", "warning");
      })
      .finally(() => hideLoader());
  };

  const handleDeleteClick = (Id) => {
    swal({
      title: "Are you sure, you want to delete this Courier Type ?",
      text: "",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        let Param = { DeleteID: Id, DeleteType: 9 };
        CommonService.CheckMappedItem(Param).then((response) => {
          if (response.data === 1) {
            dispatch(
              courierActions.deleteCourierType({
                CourierTypeID: Id,
                DeletedBy: currentUser.Id,
              })
            );
          } else {
            Toastr("This Courier is already mapped", "warning");
            hideLoader();
          }
        });
      }
    });
  };
  // handleDeleteClick
  useEffect(() => {
    if (deleteCourierResponse === 1) {
      Toastr("Courier Type details deleted successfully", "success");
      dispatch(courierActions.getCourierTypeAll());
    } else if (deleteCourierResponse === -1) {
      Toastr("Error ", "warning");
    }
  }, [deleteCourierResponse]);
  // Courier Add And Update
  useEffect(() => {
    if (courierResponse === 1) {
      Toastr("Courier Type details added successfully", "success");
      dispatch(courierActions.getCourierTypeAll());
      newFormData.CourierTypeID = newFormData.StateID = 0;

      setOpenModal(false);
      setAddFormData(newFormData);
    } else if (courierResponse === 2) {
      Toastr("Courier Type details updated Successfully", "success");
      dispatch(courierActions.getCourierTypeAll());
      setOpenModal(false);
      setAddFormData(newFormData);
    } else if (courierResponse === -1) {
      Toastr("Courier Type Name already exists ", "warning");
    }
  }, [courierResponse]);

  ///  export  //
  const handleClickPDF = () => {
    let title = "CourierTypeList";
    const columnStyles = {
      CourierTypeName: { halign: "left", cellWidth: 60 },
      Description: { halign: "left", cellWidth: 70 },
      CreatedByName: { halign: "center", cellWidth: 40 },
      CreatedDateString: { halign: "left", cellWidth: 30 },
      StatusName: { halign: "center", cellWidth: 40 },
    };

    generatePDF(finalTableData, generateColumns, true, title, columnStyles);
  };
  const handleClickExcel = () => {
    let title = "CourierTypeList";
    let generateExcelColumns = [
      "Courier Type Name",
      "Description",
      "Created By Name",
      "Created Date",
      "Status",
    ];
    let new_CourierList =
      finalTableData &&
      finalTableData.map(function (obj) {
        return {
          CourierTypeName: obj.CourierTypeName,
          Description: obj.Description,
          CreatedByName: obj.CreatedByName,
          CreatedDateString: obj.CreatedDateString,
          StatusName: obj.StatusName,
        };
      });

    generateXlsx(new_CourierList, generateExcelColumns, title);
  };

  return (
    <>
      <PageTitle activeMenu="Courier Type" motherMenu="Master" />
      <ToastContainer />
      <div className="card">
        <div className="card-header">
          <h4 className="card-title header-title">Courier Type List</h4>
          <div className="float-sm-end">
            {courierTypeList && courierTypeList.length > 0 && (
              <>
                <Button
                  className="me-2"
                  variant="danger btn-rounded"
                  onClick={handleClickPDF}
                >
                  <span className="btn-icon-start text-danger">
                    <i className="fa fa-solid fa-file-pdf"></i>
                    {/* <i className="fa fa-regular fa-file-excel"></i> */}
                  </span>
                  PDF
                </Button>
                <Button
                  className="me-2"
                  variant="secondary btn-rounded"
                  onClick={handleClickExcel}
                >
                  <span className="btn-icon-start text-secondary">
                    {/* <i className="fa fa-solid fa-file-pdf"></i> */}
                    <i className="fa fa-regular fa-file-excel"></i>
                  </span>
                  Excel
                </Button>
              </>
            )}
            <Button
              className="me-2"
              variant="primary btn-rounded"
              onClick={handlePoupClick}
            >
              <span className="btn-icon-start text-primary">
                <i className="fa fa-plus color-info" />
              </span>
              Add
            </Button>
          </div>
        </div>
        <div className="card-body">
          <Table
            columns={columns}
            data={courierTypeList}
            onDataUpdate={handleTableDataUpdate}
          />
        </div>
      </div>
      {/* <!-- Modal --> */}
      <Modal className="fade bd-example-modal-lg" show={isOpenModal} size="lg">
        <Modal.Header>
          <Modal.Title>
            {newFormData.CourierTypeID > 0
              ? "Edit Courier Type"
              : "Add Courier Type"}
          </Modal.Title>
          <Button
            variant=""
            className="btn-close"
            onClick={() => setOpenModal(false)}
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="text-black font-w500">
                  Courier Type Name<span className="text-danger">*</span>
                </label>
                <div className="contact-name">
                  <input
                    type="text"
                    className={`form-control ${
                      submitted &&
                      !addFormData.CourierTypeName &&
                      "border-danger"
                    }`}
                    autoComplete="off"
                    name="CourierTypeName"
                    required="required"
                    onChange={handleChange}
                    value={newFormData.CourierTypeName}
                    placeholder="First Name"
                    maxLength={50}
                  />
                  <span className="validation-text"></span>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <label className="text-black font-w500">Description</label>
                <div className="contact-name">
                  <input
                    type="text"
                    className={"form-control"}
                    autoComplete="off"
                    name="Description"
                    required="required"
                    onChange={handleChange}
                    placeholder="Description"
                    value={newFormData.Description}
                    maxLength={200}
                  />
                  <span className="validation-text"></span>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 mb-5">
                <label className="text-black font-w500">Active</label>
                <div>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckDefault"
                      name="Status"
                      checked={newFormData.Status === 1 ? true : false}
                      onChange={(event) => handleCkBoxChange(event, "Status")}
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="danger light" onClick={() => setOpenModal(false)}>
            Close
          </Button>
          <Button
            variant=""
            // onClick={() => setLargeModal(false)}
            onClick={handleSubmit}
            className="btn btn-primary"
          >
            {newFormData.CourierTypeID > 0 ? "Update" : "Add"}
          </Button>
        </Modal.Footer>
      </Modal>

      {loader}
    </>
  );
};

export default CourierType;
